// eslint-disable-next-line import/named
import { createGlobalStyle, DefaultTheme } from 'styled-components';
import { isMobile } from 'react-device-detect';

const GlobalStyle = createGlobalStyle<{ theme: DefaultTheme }>` 
 
  html, body {
    margin: 0;
    padding: 0;
    min-height: 100%;
    overflow-x: hidden;         /* Prevent horizontal scroll */
    touch-action: pan-y;        /* Allow vertical scroll only */
    -webkit-overflow-scrolling: touch;  /* iOS smooth scroll */
    -ms-overflow-style: none;
    font-family: ${({ theme }) => theme.fontFamilies.Arimo};
  }

  body.bg-gray {
    background-color: #eee;
  }

  div, h1, h2, h3, h4, h5, h6, p {
    white-space: pre-wrap;
  }
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -ms-overflow-style: none;
  }

  *::-webkit-scrollbar {
    display: none;
  } 
  a, a:visited {
    text-decoration: none;
    color: rgb(87, 120, 206);
  }
  a:hover {
    text-decoration: underline;
  }

  button, input {
    border: none;
    outline: none;
    background-color: transparent;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  [class*=Snackbar_snackbar-wrapper-bottom-center] {
    margin: 0!important;
    bottom: 0!important;
  }

  [class*=Snackbar_snackbar__text] {
      padding-top: 8px!important;
      padding-bottom: 8px!important;
  }

  .grecaptcha-badge {
    display: none;
  }

  .ios-gte-17 ::cue {
    font-size: 0.7em;
  }

  .driverjs-no-overlay .driver-overlay {
    display: none;
  }

  /* ---- summary ---- */
  .flickity-enabled {
    position: relative;
  }

  /* ---- summary flickity-button ---- */

  .flickity-button {
    position: absolute;
    background: ${isMobile ? 'hsla(0, 0%, 100%, 0.75)' : '#c3c3c3'};
    border: none;
    color: ${isMobile ? '#333' : 'white'};
    transition: background 0.2s ease-in-out;
  }

  .flickity-button:hover {
    background: ${isMobile ? 'white' : '#b4b3b3'};
    cursor: pointer;
  }

  .flickity-button:focus {
    outline: none;
    box-shadow: 0 0 0 5px #19f;
  }

  .flickity-button:active {
    opacity: 0.6;
  }

  .flickity-button:disabled {
    opacity: 0;
    cursor: auto;
    /* prevent disabled button from capturing pointer up event. #716 */
    pointer-events: none;
  }

  .flickity-button-icon {
    fill: ${isMobile ? '#333' : 'white'};
  }

  /* ---- summary previous/next buttons ---- */

  .flickity-prev-next-button {
    top: 50%;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    /* vertically center */
    transform: translateY(-50%);
  }
  
  .flickity-prev-next-button.previous {
    left: ${isMobile ? 0 : -50}px;
  }
  .flickity-prev-next-button.next {
    right: ${isMobile ? 0 : -50}px;
  }
  /* right to left */
  .flickity-rtl .flickity-prev-next-button.previous {
    left: auto;
    right: ${isMobile ? 10 : -50}px;
  }
  .flickity-rtl .flickity-prev-next-button.next {
    right: auto;
    left: ${isMobile ? 10 : -50}px;
  }

  .flickity-prev-next-button .flickity-button-icon {
    position: absolute;
    left: 20%;
    top: 20%;
    width: 60%;
    height: 60%;
  }

  .flickity-viewport {
    overflow: hidden;
  }
`;

export default GlobalStyle;
